/** Typogram official social URLs + brand hover colors (inspired by classic FA brand colors). */
export const TYPOGRAM_SOCIAL = [
  {
    href: "https://youtube.com/@typogram_in",
    label: "YouTube",
    icon: "YT",
    hover: "#cd201f",
  },
  {
    href: "https://instagram.com/typogram_in",
    label: "Instagram",
    icon: "IG",
    hover: "#e4405f",
  },
  {
    href: "https://linkedin.com/company/typogramm",
    label: "LinkedIn",
    icon: "in",
    hover: "#0a66c2",
  },
  {
    href: "https://twitter.com/typogram_in",
    label: "Twitter",
    icon: "X",
    hover: "#1d9bf0",
  },
  {
    href: "https://t.me/typogram_in",
    label: "Telegram",
    icon: "TG",
    hover: "#229ed9",
  },
];

/** Job Updates page — Typogram app & community links */
export const TYPOGRAM_JOB_RESULTS_LINKS = {
  appDownload: "https://play.google.com/store/apps/details?id=com.typogram.typogram_app",
  webApp: "https://typogram.in",
  whatsapp:
    "https://wa.me/?text=" +
    encodeURIComponent("Check latest govt jobs & typing practice on Typogram: https://typogram.in/job-updates"),
  telegram: "https://t.me/typogram_in",
};
